export class BadRequestError extends Error {
  /** HTTP Status Code */
  readonly status: number;

  readonly errorMessage: string | Object | string[] | any;

  readonly internalCode: string;

  constructor(status: number, errorMessage: string | Object | any, internalCode: string) {
    super();
    this.internalCode = internalCode;
    this.status = status;
    this.errorMessage = errorMessage;
  }
}
